<!--
 * @Date: 2021-07-23 09:33:40
 * @LastEditTime: 2021-07-29 16:50:05
 * @Description: 示范园区子页
 * @FilePath: \shangwu_web\src\views\demonstration\map\parksMap.vue
-->
<template>
  <div style="" id="map" ref="map">

  </div>
</template>

<script scoped>
import mapJson from '../../../store/anhuiMap.json'
import * as echarts from 'echarts'
import {areaServices, serviesNum} from '@/apis/apis.js'

export default {
  name: 'parksMap',
  data(){
    return {
      //地图json文件
      map:mapJson,
      mapOption: null,
      barOption: null,
      currentOption: null,
      myChart: null,
      // 各个城市服务中心
      seriveCenter: [],
    }
  },
  methods: {
    leftCenterMap () {
      let that=this
      this.myChart = echarts.init(document.getElementById('map')) // 拿到一个实例
      echarts.registerMap('安徽省', mapJson, {})//引入地图文件
      let data = [
            {
              value: "341100",
              name: "滁州市"
            },
            {
              value: "341200",
              name: "阜阳市"
            },
            {
              value: "340800",
              name: "安庆市"
            },
            {
              value: "341800",
              name: "宣城市"
            },
            {
              value: "341000",
              name: "黄山市"
            },
            {
              value: "341500",
              name: "六安市"
            },
            {
              value: "340100",
              name: "合肥市",
              
            },
            {
              value: "341300",
              name: "宿州市"
            },
            {
              value: "341600",
              name: "亳州市"
            },
            {
              value: "341700",
              name: "池州市"
            },
            {
              value: "340200",
              name: "芜湖市"
            },
            {
              value: "340300",
              name: "蚌埠市"
            },
            {
              value: "340500",
              name: "马鞍山市"
            },
            {
              value: "340700",
              name: "铜陵市"
            },
            {
              value: "340400",
              name: "淮南市"
            },
            {
              value: "340600",
              name: "淮北市"
            }  
          ];
      this.mapOption = {    
        // 提示框配置
        tooltip: {
          triggerOn:'none',
          enterable:true,
          padding:0,
          borderColor:'rgba(55,111,200,.8)',
          backgroundColor :'rgba(55,111,200,.8)',
          confine: true,
          extraCssText:"border-radius:8px",
          formatter: function (params, ticket, callback) {
            let str=''
            let query = Array.isArray(params.value) ? params.value.pop() : params.value
            that.$ajaxGet(`${areaServices}/${query}`, null).then(res => {
              if (res.data.code != 0) {
                that.$message({
                  title: "错误",
                  type:"error",
                  message:res.data.msg + ",请重新刷新",
                })
              } else {
                let list = res.data.data.records
                str=`<div style="border-radius: 8px;overflow:hidden;background:rgba(1, 25, 69, 0.1);border-radius:8px">
                <div style="height:0.30rem;font-size:0.16rem;color:#fff;display: flex;align-items: center;width:5rem;padding:0.2rem;">
                <span style="height:0.30rem;display:inline-block;width:0.05rem;border-radius:0.05rem;background-color:#91bef9;margin-right:8px"></span>
                ${params.name}
                </div>`
                if(list.length>0){
                  str+=`<table cellpadding='0' cellspacing='0' style="width: 5rem; font-size:0.16rem;margin-top:8px;  border-radius: 8px;border:1px solid #91bef9;overflow:hidden;box-sizing: border-box;margin:auto;margin-bottom:0.2rem;" >
                <tr style="background-color:#91bef9;color:#fff;height:0.4rem;">
                <td style="border:1px solid #91bef9;">序号</td>
                <td style="border:1px solid #91bef9;">图标</td>
                <td style="border:1px solid #91bef9;">服务中心</td>
                <td style="border:1px solid #91bef9;border-right:none"">操作</td>
                </tr>`
                  list.forEach((item,index)=>{
                    str+=`<tr style="color:#fff;height:0.4rem;border:1px solid #91bef9;">
                <td style="border:1px solid #91bef9;border-left:none">${index+1}</td>
                <td style="border:1px solid #91bef9;"><img src="${item.imgUrl}" alt="" style="width:0.3rem;height:0.3rem;vertical-align: middle;"></td>
                <td style="border:1px solid #91bef9;">${item.name}</td>`
                    if(!item.website){
                      str+=`<td style="border:1px solid #91bef9;border-right:none""><span style='text-decoration: none;color:#fff'>暂无网址</span></td>
                </tr>`
                    }else{
                      str+=`<td style="border:1px solid #91bef9;border-right:none""><a href=${item.website} style='text-decoration: none;color:#fff' target="_bink">查看</a></td>
                </tr>`
                    }
                
                  })
                }else{
                  str+=`<p style="height:0.30rem;font-size:0.16rem;color:#fff";>暂无数据</p>`
                }
                callback(ticket, str)
              }
            }).catch(err => {
              that.$alert(err + "网络请求异常，请稍后再试！", "警告", {
                confirmButtonText: '确定',
                type:"error",
                callback: ()=> {
                  location.reload()
                }
              })
            })
            return '<div style="height:0.30rem;font-size:0.16rem;color:#fff;justify-content: center;display: flex;align-items: center;width:5rem;height:1rem">loading...</div>';
          }
        },
        geo: {
          show: true,
          type: 'map',
          id: 'anhui',
          map: '安徽省',
          silent: true,
          itemStyle: {
            normal: {
              shadowColor: "rgba(72, 120, 179, 0.8)", 
              shadowOffsetX: -5,
              shadowOffsetY: 10,
              shadowBlur: 5
            }
          },
          zoom:0.8,
        }, 
        series: [
        {
          id:'anhui',
          type: 'map',                
          data: data, 
          map: '安徽省',//地图名称'
          zoom:0.8,
          //地图样式 城市边界 阴影等
          itemStyle:{
            
            borderType : 'solid',
            borderColor :'#458EE5',
            label: { 
            //默认显示省份
              show: true,
              fontSize:'0.14rem'
            },
            
          },
          label: { 
            show: true,//显示省份标签 
            fontSize:'0.12rem'
          }
          } 
        ],
        visualMap: {
          x: '-1000 px', //图例横轴位置
          y: '1000 px', //图例纵轴位置
          splitList: [
            { start: 340100, end: 340100, label: '合肥市', color: '#cfc5de' },
            { start: 340300, end: 340300, label: '蚌埠市', color: '#f1ebd1' },
            { start: 340600, end: 340600, label: '淮北市', color: '#feffdb' },
            { start: 341600, end: 341600, label: '亳州市', color: '#e0cee4' },
            { start: 341300, end: 341300, label: '宿州市', color: '#fde8cd' },
            { start: 341200, end: 341200, label: '阜阳市', color: '#e4f1d7' },
            { start: 340400, end: 340400, label: '淮南市', color: '#fffed7' },
            { start: 341100, end: 341100, label: '滁州市', color: '#e4f1d7' },
            { start: 341500, end: 341500, label: '六安市', color: '#e4f1d7' },
            { start: 340500, end: 340500, label: '马鞍山市', color: '#fffed7' },
            { start: 340200, end: 340200, label: '芜湖市', color: '#fffed8' },
            { start: 341800, end: 341800, label: '宣城市', color: '#dccee7' },
            { start: 340700, end: 340700, label: '铜陵市', color: '#fffed7' },
            { start: 341700, end: 341700, label: '池州市', color: '#fce8cd' },
            { start: 340800, end: 340800, label: '安庆市', color: '#ddceeb' },
            { start: 341000, end: 341000, label: '黄山市', color: '#e4f1d3' }
          ]
        },      
      }
      const dom = 800;
      const barWidth = dom / 20;
      let colors = []
      for(let i = 0;i< 16;i++){
          colors.push({
              type: 'linear',
              x: 0,
              x2: 1,
              y: 0,
              y2: 0,
              colorStops: [
              {
                  offset: 0,
                  color: '#fda085' // 最左边
              }, {
                  offset: 0.5,
                  color: '#f6d365' // 左边的右边 颜色
              }, {
                  offset: 0.5,
                  color: '#fda085' // 右边的左边 颜色
              }, {
                  offset: 1,
                  color: '#f6d365'
              }]
              // colorStops: [
              // {
              //     offset: 0,
              //     color: '#3B80E2' // 最左边
              // }, {
              //     offset: 0.5,
              //     color: '#83bff6' // 左边的右边 颜色
              // }, {
              //     offset: 0.5,
              //     color: '#188df0' // 右边的左边 颜色
              // }, {
              //     offset: 1,
              //     color: '#188df0'
              // }]
                })
      }
      this.barOption = {
        grid: {
          top: 160,
        },
        yAxis: {
          type: 'value',
          name: '服务中心数量',
          nameLocation: 'center',
          nameGap: 25,
          axisLine: {
            show: true,
            lineStyle: {
                color: '#b1b19c',
            },
        },
        },
        xAxis: {
          type: 'category',
          offset: 15,
          axisLabel: {
            rotate: 30
          },         
          data: this.seriveCenter.map(function (item) {
            return item.name;
          })
        },
        
        animationDurationUpdate: 1000,
        tooltip: {},
        series: [
        {
            type: 'bar',
            barWidth: barWidth,
            itemStyle: {
                normal: {
                    color: function(params) {
                        return colors[params.dataIndex % 17];
                    }
                }
            },
            label: {
                show: false,
                position: [barWidth / 2, -(barWidth + 20)],
                color: '#ffffff',
                fontSize: 14,
                fontStyle: 'bold',
                align: 'center',
            },
            data: this.seriveCenter.map(function (item,index) {
            return item.value;
          }),
        },
        {
            z: 2,
            type: 'pictorialBar',
            data: this.seriveCenter.map(function (item,index) {
            return item.value;
          }),
            symbol: 'diamond',
            symbolOffset: [0, '50%'],
            symbolSize: [barWidth, barWidth * 0.5],
            itemStyle: {
                normal: {
                    color: function(params) {
                        return colors[params.dataIndex % 17];
                    },
                }
            },
        },
        {
            z: 3,
            type: 'pictorialBar',
            symbolPosition: 'end',
            data: this.seriveCenter.map(function (item,index) {
            return item.value;
          }),
            symbol: 'diamond',
            symbolOffset: [0, '-50%'],
            symbolSize: [barWidth, barWidth * 0.5],
            itemStyle: {
                normal: {
                    borderWidth: 0,
                    color: function(params) {
                        return colors[params.dataIndex % 17].colorStops[0].color;
                    },
                }
            },
        },
    ],
      };
      this.currentOption = this.mapOption;
      this.myChart.setOption(this.mapOption);
      this.myChart.off('click');
      this.myChart.on('click',(p) => {
        var evt = p.event;
        this.myChart.dispatchAction({ // 指令调用tooltip显示
          type: 'showTip',
          x: evt.offsetX,
          y: evt.offsetY,
          position: [evt.offsetX-60,evt.offsetY-60]
        });
      });
      window.addEventListener('resize',()=>{this.myChart.resize()})
    },   
    renderEcharts(){
      // 新建一个promise对象
      let newPromise = new Promise((resolve) => {
        resolve()
      })
      //然后异步执行echarts的初始化函数
      newPromise.then(() => {
        //	此dom为echarts图标展示dom
        this.leftCenterMap()
      })
      
    },
    // 在柱状图和地图之间切换
    switchMethod() {
      // this.mapOption.geo.show = false;
      this.currentOption = this.currentOption === this.mapOption ? this.barOption : this.mapOption;
      this.myChart.clear(); 
      this.myChart.setOption(this.currentOption, true);
      // setTimeout(() => {
      //   this.mapOption.geo.show = true;
      //   this.myChart.setOption(this.currentOption, true);
      // }, 800)
    },
    // 获取各个城市服务中心的数量
    getCitiesServe() {
      this.$ajaxGet(serviesNum).then(({data}) => {
        if(data.code === 0) {
          this.seriveCenter = data.data.map(function(item) {
            let newItem = {};
            newItem.name = item.cityName;
            newItem.value = item.cityCount;
            return newItem
          })
        }
        this.renderEcharts()
        this.$emit('citySerive', this.seriveCenter)
      })
    }

  },
  
  mounted() {
    
    // this.drawLine()
    this.getCitiesServe()
  }
}
</script>

<style lang="less" scoped>
@media all and (min-width:750px){
  #map{
    width: 100%; 
    height: 100%;
  }
}
@media screen and (max-width:750px){}

</style>